import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const getSambaUser = async () => {
  const response = await axiosMethods.get(RestAPI.SAMBA_USER, null, true, true);
  return response;
};

export const postSambaUser = async (username, password) => {
  const data = {
    Username: username,
    Password: password,
  };
  const response = await axiosMethods.post(RestAPI.SAMBA_USER, data);
  return response;
};

export const putSambaUser = async (username, password) => {
  const data = {
    Username: username,
    Password: password,
  };
  const response = await axiosMethods.put(RestAPI.SAMBA_USER, data);
  return response;
};
